/* import __COLOCATED_TEMPLATE__ from './screen-reader-announcer.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./screen-reader-announcer.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());